import * as ko from "knockout";
import Bao from "./../services/bao-service";
import ConfigurationItemViewModel from "./configuration-item";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import "./../bindings/bao-number-box";
import "./../bindings/bao-date-time-picker";
function OfferViewModel(tabPage) {
    var self = this;
    ConfigurationItemViewModel.call(this, tabPage);
    self.AllowSave = ko.observable(true);
    self.ConfigurationItemId = ko.observable();
    self.SelectedApplicantItem = ko.observable();
    self.SelectedOwnerItem = ko.observable();
    self.ApplicantId = ko.observable();
    self.ApplicantCustomer = ko.observable();
    self.ApplicantConzern = ko.observable();
    self.ApplicantStatus = ko.observable();
    self.ApplicantTel = ko.observable();
    self.ApplicantAccountAssignment = ko.observable();
    self.ApplicantDepartment = ko.observable();
    self.ApplicantWerk = ko.observable();
    self.ApplicantBuilding = ko.observable();
    self.ApplicantRoom = ko.observable();
    self.OwnerId = ko.observable();
    self.OwnerCustomer = ko.observable();
    self.OwnerConzern = ko.observable();
    self.OwnerStatus = ko.observable();
    self.OwnerTel = ko.observable();
    self.OwnerAccountAssignment = ko.observable();
    self.OwnerDepartment = ko.observable();
    self.OwnerWerk = ko.observable();
    self.OwnerBuilding = ko.observable();
    self.OwnerRoom = ko.observable();
    self.CompleteCheck = function () {
        var isComplete = true;
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.OwnerChanged = function (selectedValue) {
        if (selectedValue != null) {
            self.OwnerCustomer(selectedValue.CustomerName);
            self.OwnerConzern();
            self.OwnerStatus(selectedValue.ConfigurationItemStatusName);
            self.OwnerTel(selectedValue.MobilePhone);
            self.OwnerAccountAssignment(selectedValue.AccountAssignment);
            self.OwnerDepartment(selectedValue.DepartmentName);
            self.OwnerWerk();
            self.OwnerBuilding(selectedValue.BuildingName);
            self.OwnerRoom(selectedValue.Room);
        }
        else {
            self.OwnerCustomer("");
            self.OwnerConzern("");
            self.OwnerStatus("");
            self.OwnerTel("");
            self.OwnerAccountAssignment("");
            self.OwnerDepartment("");
            self.OwnerWerk("");
            self.OwnerBuilding("");
            self.OwnerRoom("");
        }
    };
    self.ApplicantChanged = function (selectedValue) {
        if (selectedValue != null) {
            self.ApplicantCustomer(selectedValue.CustomerName);
            self.ApplicantConzern();
            self.ApplicantStatus(selectedValue.ConfigurationItemStatusName);
            self.ApplicantTel(selectedValue.MobilePhone);
            self.ApplicantAccountAssignment(selectedValue.AccountAssignment);
            self.ApplicantDepartment(selectedValue.DepartmentName);
            self.ApplicantWerk();
            self.ApplicantBuilding(selectedValue.BuildingName);
            self.ApplicantRoom(selectedValue.Room);
        }
        else {
            self.ApplicantCustomer("");
            self.ApplicantConzern("");
            self.ApplicantStatus("");
            self.ApplicantTel("");
            self.ApplicantAccountAssignment("");
            self.ApplicantDepartment("");
            self.ApplicantWerk("");
            self.ApplicantBuilding("");
            self.ApplicantRoom("");
        }
    };
    self.toolbarButtonClicked = function (btn) {
        if (tabPage != null && tabPage.IsActiveTab != null && tabPage.IsActiveTab() === true) {
            var functionString = btn.ActionKey();
            switch (functionString) {
                case "OfferExportObject":
                    self.ExportOfferToObject(self.ConfigurationItemId());
                    break;
            }
        }
    };
    self.ExportOfferToObject = function () {
        return Bao.post("ConfigurationItem/ExportOfferToObject", JSON.stringify({
            offerModel: self.MinimizeEntity(ko.map.toJS(self))
        }), function (result) {
            if (result.Model != null) {
                ko.map.fromJS(result.Model, self);
            }
        });
    };
    self.LoadOwnerApplicantData = function () {
        return Bao.post("ConfigurationItem/GetOwnerAndApplicantData", JSON.stringify({
            ownerId: self.OwnerId(),
            applicantId: self.ApplicantId()
        }), function (result) {
            if (result.Owner != null) {
                self.OwnerChanged(result.Owner);
            }
            if (result.Applicant != null) {
                self.ApplicantChanged(result.Applicant);
            }
        });
    };
    self.loaded = function () {
        self.AllowSave(true);
        self.LoadOwnerApplicantData().then(function () {
            self.InitPaging();
            tabPage.DirtyFlag.reset();
            tabPage.IsLoading(false);
            self.Initialized(true);
            self.Focus();
            BaoMenu.registerEvent(function (btn) {
                self.toolbarButtonClicked(btn);
            });
        });
    };
}
;
Bao.inherit(OfferViewModel, ConfigurationItemViewModel);
OfferViewModel.prototype.DeleteMessageKey = "msgDeleteOffer";
OfferViewModel.prototype.RefreshUrl = "ConfigurationItem/GetOffer";
OfferViewModel.prototype.SaveUrl = "ConfigurationItem/SaveOffer";
OfferViewModel.prototype.DeleteUrl = "ConfigurationItem/DeleteOffer";
OfferViewModel.prototype.PermissionRefresh = "OfferRefresh";
OfferViewModel.prototype.PermissionSave = "OfferSave";
OfferViewModel.prototype.PermissionDelete = "OfferDelete";
OfferViewModel.prototype.PermissionOfferExportObject = "OfferExportObject";
OfferViewModel.prototype.ConfigurationItemTypeKeyCategory = "Offer";
OfferViewModel.prototype.PermissionAuditTrail = "OfferAudit";
export default OfferViewModel;